import * as Yup from 'yup';

export const profileSchema = Yup.object({
    firstName: Yup.string().required('First Name is Required'),
    lastName: Yup.string().required("Last Name is required"),
    birthDate: Yup.string().required("Date of Birth is Required"),
    mobile: Yup.string()
        .matches(/^\d{7,}$/, 'Phone Number must be at least 7 digits')
        .required('Phone Number is required'),
    address1: Yup.string().required("Address 1 is required"),
    address2: Yup.string().required("Address 2 is required"),
    city: Yup.string().required("City is Required"),
    country: Yup.string().required("Country Name is Required"),
    county: Yup.string().required("County Name is Required"),
    password: Yup.string()
    .matches(
      /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=]).{6,}$/,
      'Password must be  one uppercase letter, one lowercase letter,numbers and includes special characters'
    )
});
